export default __webpack_public_path__ + "static/media/compiegne13.cabc9e3c.jpg";